'use client'

import React from 'react'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import styles from './styles.module.css'

const CtaBanner: React.FC = () => {
	const { openConsultationModal } = useModal()

	return (
		<section className={styles.banner}>
			<div className={styles.bannerContainer}>
				<div className={styles.content}>
					<div className={styles.textSection}>
						<div className={styles.textContainer}>
							<div className={styles.titleContainer}>
								<h2 className={styles.title}>
									Переведите ваши B2B-продажи на скорость розничного ритейла
								</h2>
							</div>
							<div className={styles.descriptionContainer}>
								<p className={styles.description}>
									Покажем работу платёжного интерфейса изнутри и поможем настроить сценарии под ваши бизнес‑процессы
								</p>
							</div>
						</div>

						<button className={styles.button} onClick={openConsultationModal}>
							<span className={styles.buttonText}>Получить консультацию</span>
							<svg className={styles.buttonIcon} viewBox='0 0 16 16' fill='none'>
								<path d='M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z' fill='#151515' />
							</svg>
						</button>
					</div>
				</div>
			</div>
		</section>
	)
}

CtaBanner.displayName = 'CtaBanner'

export default CtaBanner
